<template>
  <vs-row vs-justify="center">
    <vs-col vs-lg="12" vs-xs="12" vs-sm="12">
      <vs-card>
        <!-- Header -->
        <div class="d-md-flex align-items-center pb-2">
          <h3 class="card-title mb-0">
            {{ formdata.isEdit ? 'Edit Account Payable' : 'Input Account Payable' }}
            <!-- Badge Jenis Hutang -->
            <span
              class="jenis-badge ml-2"
              :class="formdata.jenis_hutang === 'impor' ? 'badge-impor' : 'badge-lokal'"
            >
              {{ formdata.jenis_hutang === 'impor' ? 'IMPOR' : 'LOKAL' }}
            </span>
          </h3>
          <div class="ml-auto">
            <vs-button @click="backpage" color="danger" type="filled" class="mt-4 mt-md-0" icon="highlight_off" v-focus>
              Batal
            </vs-button>
          </div>
        </div>

        <!-- Alert Error -->
        <vs-alert v-if="errors.length" class="mb-3 mt-2" color="danger">
          <b>Terdapat Kesalahan..</b>
          <ul class="common-list">
            <li v-for="error in errors" :key="error">{{ error }}</li>
          </ul>
        </vs-alert>

        <!-- ====== BAGIAN 1: JENIS HUTANG (paling atas, pilihan wajib) ====== -->
        <div class="jenis-hutang-selector mt-3 mb-2">
          <label class="selector-label">Jenis Hutang Usaha <span class="text-danger">*</span></label>
          <div class="selector-options">
            <div
              class="selector-item"
              :class="{ 'selected-lokal': formdata.jenis_hutang === 'lokal' }"
              @click="formdata.jenis_hutang = 'lokal'"
            >
              <i class="mdi mdi-home-city mr-1"></i>
              <span>Hutang Usaha <strong>Lokal</strong></span>
              <small class="d-block text-muted" style="font-size:0.75em;">Supplier dalam negeri</small>
            </div>
            <div
              class="selector-item"
              :class="{ 'selected-impor': formdata.jenis_hutang === 'impor' }"
              @click="formdata.jenis_hutang = 'impor'"
            >
              <i class="mdi mdi-airplane mr-1"></i>
              <span>Hutang Usaha <strong>Impor</strong></span>
              <small class="d-block text-muted" style="font-size:0.75em;">Supplier luar negeri</small>
            </div>
          </div>
          <!-- Info COA yang akan digunakan -->
          <div class="coa-info mt-1">
            <i class="mdi mdi-information-outline"></i>
            Kredit jurnal →
            <strong>{{ formdata.jenis_hutang === 'impor' ? 'COA HUTANG USAHA IMPOR' : 'COA HUTANG USAHA LOKAL' }}</strong>
            
          </div>
        </div>

        <hr class="mt-2 mb-3" />

        <!-- ====== BAGIAN 2: DATA TRANSAKSI ====== -->
        <vs-row>
          <!-- Tanggal -->
          <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
            <div class="vs-component vs-con-input-label vs-input w-100 mt-4 vs-input-primary">
              <label class="vs-input--label">Tanggal <span class="text-danger">*</span></label>
              <div class="vs-con-input">
                <date-picker
                  v-model="formdata.tanggal"
                  format="DD-MM-YYYY"
                  value-type="format"
                  placeholder="Pilih Tanggal"
                  input-class="vs-input--input"
                  :disabled-date="disabledBeforeYear"
                />
              </div>
            </div>
          </vs-col>

          <!-- Jatuh Tempo -->
          <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
            <div class="vs-component vs-con-input-label vs-input w-100 mt-4 vs-input-primary">
              <label class="vs-input--label">Jatuh Tempo</label>
              <div class="vs-con-input">
                <date-picker
                  v-model="formdata.jatuh_tempo"
                  format="DD-MM-YYYY"
                  value-type="format"
                  placeholder="Pilih Jatuh Tempo"
                  input-class="vs-input--input"
                />
              </div>
            </div>
          </vs-col>

          <!-- No Referensi -->
          <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
            <vs-input
              label="No. Referensi / Invoice"
              class="w-100 mt-4"
              v-model="formdata.no_referensi"
              placeholder="No. invoice / nota"
            />
          </vs-col>

          <!-- Nomor FP -->
          <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
            <vs-input
              label="Nomor FP (Faktur Pajak)"
              class="w-100 mt-4"
              v-model="formdata.nomor_fp"
              placeholder="Nomor Faktur Pajak"
            />
          </vs-col>
        </vs-row>

        <vs-row>
          <!-- Supplier -->
          <vs-col vs-lg="5" vs-xs="12" vs-sm="6">
            <vs-select
              class="w-100 mt-4"
              autocomplete
              label="Supplier / Rekanan"
              v-model="formdata.sup_id"
              @change="onSupplierChange"
            >
              <vs-select-item
                v-for="(s, i) in supplierOptions"
                :key="i"
                :value="s.kode"
                :text="s.nama"
              />
            </vs-select>
          </vs-col>

          <!-- Nama Supplier manual -->
          <vs-col vs-lg="5" vs-xs="12" vs-sm="6">
            <vs-input
              label="Nama Supplier (isi jika tidak ada di daftar)"
              class="w-100 mt-4"
              v-model="formdata.nama_supplier"
              placeholder="Nama supplier / rekanan"
            />
          </vs-col>
        </vs-row>

        <vs-row>
          <vs-col vs-lg="10" vs-xs="12" vs-sm="10">
            <vs-input
              label="Keterangan"
              class="w-100 mt-4"
              v-model="formdata.keterangan"
              placeholder="Keterangan transaksi"
            />
          </vs-col>
        </vs-row>

        <hr class="mt-4 mb-2" />

        <!-- ====== BAGIAN 3: RINCIAN DETAIL ====== -->
        <h5 class="mb-2 mt-3">
          Rincian Jurnal
          <span class="text-muted" style="font-size:0.8em;font-weight:normal;">
            — Debit: Akun Biaya/Beban | Kredit: Hutang Usaha {{ formdata.jenis_hutang === 'impor' ? 'Impor' : 'Lokal' }}
          </span>
        </h5>

        <!-- Detail Rows -->
        <div
          v-for="(row, idx) in detailRows"
          :key="idx"
          class="detail-row mb-2 p-2"
          :class="idx % 2 === 0 ? 'row-even' : 'row-odd'"
        >
          <vs-row>
            <!-- Kode Perkiraan -->
            <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
              <vs-select class="w-100 mt-2" autocomplete label="Kode Perkiraan (Debit)" v-model="row.kode_perk" @change="onPerkChange(row)">
                <vs-select-item
                  v-for="(opt, i) in perkOptions"
                  :key="i"
                  :value="opt.kode_perk"
                  :text="opt.kode_perk + ' - ' + (opt.nama_perk || opt.nama || '')"
                />
              </vs-select>
            </vs-col>

            <!-- Nama Perkiraan -->
            <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
              <vs-input label="Nama Perkiraan" class="w-100 mt-2" v-model="row.nama_perk" placeholder="Nama akun" />
            </vs-col>

            <!-- Keterangan baris -->
            <vs-col vs-lg="3" vs-xs="12" vs-sm="4">
              <vs-input label="Keterangan" class="w-100 mt-2" v-model="row.keterangan" placeholder="Keterangan baris" />
            </vs-col>

            <!-- Nilai -->
            <vs-col vs-lg="2" vs-xs="12" vs-sm="4">
              <vs-input label="Nilai (Rp)" class="w-100 mt-2" v-model="row.nilai" v-currency="currencyOpts" placeholder="0" />
            </vs-col>

            <!-- Hapus baris -->
            <vs-col vs-lg="1" vs-xs="12" vs-sm="2">
              <div class="mt-2" style="padding-top:22px;">
                <vs-button
                  color="danger" icon="remove" type="flat"
                  @click="removeRow(idx)"
                  v-if="detailRows.length > 1"
                  title="Hapus baris"
                />
              </div>
            </vs-col>
          </vs-row>
        </div>

        <!-- Tambah Baris & Total -->
        <vs-row class="mt-2 align-items-center">
          <vs-col vs-lg="6" vs-xs="12">
            <vs-button color="primary" icon="add" type="gradient" @click="addRow">Tambah Baris</vs-button>
          </vs-col>
          <vs-col vs-lg="6" vs-xs="12">
            <div class="total-box text-right mr-2">
              <table class="ml-auto total-table">
                <tr>
                  <td class="pr-3 text-muted">Total Debit (Biaya)</td>
                  <td class="text-right"><strong>{{ totalFormatted }}</strong></td>
                </tr>
                <tr>
                  <td class="pr-3 text-muted">Kredit ({{ formdata.jenis_hutang === 'impor' ? 'Hutang Impor' : 'Hutang Lokal' }})</td>
                  <td class="text-right kredit-val"><strong>{{ totalFormatted }}</strong></td>
                </tr>
              </table>
            </div>
          </vs-col>
        </vs-row>

        <br />

        <!-- Action Buttons -->
        <div class="btn-alignment mt-4">
          <vs-button color="success" type="filled" @click.stop.prevent="checkForm">
            <i class="mdi mdi-content-save mr-1"></i> Simpan & Buat Jurnal
          </vs-button>
          <vs-button color="dark" @click="backpage" type="filled">Batal</vs-button>
        </div>
      </vs-card>
    </vs-col>
  </vs-row>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { CurrencyDirective, parseCurrency } from 'vue-currency-input';

export default {
  components: { DatePicker },
  directives: { currency: CurrencyDirective },

  data() {
    return {
      formdata: {
        isEdit:        false,
        tanggal:       '',
        jatuh_tempo:   '',
        jenis_hutang:  'lokal',   // ← 'lokal' | 'impor'
        sup_id:        null,
        nama_supplier: '',
        no_referensi:  '',
        nomor_fp:      '',
        keterangan:    '',
        opr:           '',
      },
      detailRows: [
        { kode_perk: '', nama_perk: '', keterangan: '', nilai: 0 },
      ],
      supplierOptions: [],
      perkOptions:     [],
      errors:          [],
      currencyOpts: {
        locale:   'id',
        currency: null,
      },
    };
  },

  computed: {
    totalNilai() {
      return this.detailRows.reduce((acc, r) => {
        const v = this.parseVal(r.nilai);
        return acc + (isNaN(v) ? 0 : v);
      }, 0);
    },
    totalFormatted() {
      return new Intl.NumberFormat('id-ID', { style: 'decimal', maximumFractionDigits: 2 }).format(this.totalNilai);
    },
  },

  methods: {
    backpage() {
      this.$router.go(-1);
    },
    disabledBeforeYear(date) {
      return (
        date.getFullYear() < window.$cookies.get('THN') ||
        date.getFullYear() > window.$cookies.get('THN')
      );
    },
    parseVal(val) {
      if (typeof val === 'number') return val;
      return parseCurrency(String(val || '0'), this.currencyOpts) || 0;
    },
    addRow() {
      this.detailRows.push({ kode_perk: '', nama_perk: '', keterangan: '', nilai: 0 });
    },
    removeRow(idx) {
      this.detailRows.splice(idx, 1);
    },
    onSupplierChange(val) {
      const found = this.supplierOptions.find(s => s.kode === val);
      if (found) this.formdata.nama_supplier = found.nama;
    },
    onPerkChange(row) {
      const found = this.perkOptions.find(p => p.kode_perk === row.kode_perk);
      if (found) row.nama_perk = found.nama_perk || found.nama || '';
    },
    fetchSupplier() {
      this.$http.get('/api/rekanan').then(resp => {
        this.supplierOptions = Array.isArray(resp.data) ? resp.data : [];
      }).catch(() => { this.supplierOptions = []; });
    },
    fetchPerk() {
      this.$http.get('/api/perklist').then(resp => {
        this.perkOptions = Array.isArray(resp.data) ? resp.data : [];
      }).catch(() => { this.perkOptions = []; });
    },
    checkForm() {
      this.errors = [];

      if (!this.formdata.tanggal)      this.errors.push('Tanggal belum diisi');
      if (!this.formdata.jenis_hutang) this.errors.push('Jenis hutang belum dipilih');

      const validRows = this.detailRows.filter(r => this.parseVal(r.nilai) > 0);
      if (validRows.length === 0) this.errors.push('Minimal 1 baris rincian harus diisi');

      validRows.forEach((r, i) => {
        if (!r.kode_perk) this.errors.push(`Baris ${i + 1}: Kode perkiraan (Debit) belum dipilih`);
        if (this.parseVal(r.nilai) <= 0) this.errors.push(`Baris ${i + 1}: Nilai harus lebih dari 0`);
      });

      if (this.errors.length > 0) {
        this.notifyError();
        return;
      }

      const details = validRows.map(r => ({
        kode_perk:  r.kode_perk  || null,
        nama_perk:  r.nama_perk  || null,
        keterangan: r.keterangan || null,
        nilai:      this.parseVal(r.nilai),
      }));

      const payload = {
        tanggal:       this.toYmd(this.formdata.tanggal),
        jatuh_tempo:   this.formdata.jatuh_tempo ? this.toYmd(this.formdata.jatuh_tempo) : null,
        jenis_hutang:  this.formdata.jenis_hutang,
        sup_id:        this.formdata.sup_id || null,
        nama_supplier: this.formdata.nama_supplier || '',
        no_referensi:  this.formdata.no_referensi  || '',
        nomor_fp:      this.formdata.nomor_fp      || '',
        keterangan:    this.formdata.keterangan     || '',
        opr:           this.formdata.opr || this.$store.getters.getUserName || '-',
        details,
      };

      this.$vs.loading({ type: 'radius' });

      const req = this.formdata.isEdit
        ? this.$http.put('/api/accountpayable/' + this.$route.params.ref, payload)
        : this.$http.post('/api/accountpayable', payload);

      req.then(resp => {
        this.$vs.loading.close();
        const msg = resp.data && resp.data.message ? resp.data.message : 'Data berhasil disimpan';
        this.$vs.notify({ title: 'Berhasil', text: msg, color: 'success' });
        this.$router.push({ name: 'aplist' });
      }).catch(error => {
        this.$vs.loading.close();
        if (error.response && error.response.data) {
          const errs = error.response.data.errors || {};
          Object.keys(errs).forEach(k => this.errors.push(errs[k][0]));
          if (error.response.data.error) this.errors.push(error.response.data.error);
        }
        if (!this.errors.length) this.errors.push('Terjadi kesalahan di server');
        this.notifyError();
      });
    },
    toYmd(ddmmyyyy) {
      if (!ddmmyyyy) return null;
      const parts = ddmmyyyy.split('-');
      if (parts.length === 3) {
        // If already YYYY-MM-DD
        if (parts[0].length === 4) return ddmmyyyy;
        return `${parts[2]}-${parts[1]}-${parts[0]}`;
      }
      return ddmmyyyy;
    },
    toDdmmyyyy(ymd) {
      if (!ymd) return '';
      // Handle ISO strings by taking only the date part
      const datePart = ymd.includes('T') ? ymd.split('T')[0] : ymd;
      const parts = datePart.split('-');
      if (parts.length === 3) return `${parts[2]}-${parts[1]}-${parts[0]}`;
      return ymd;
    },
    notifyError() {
      this.$vs.notify({
        title: 'Gagal Menyimpan Data',
        text: 'Klik untuk melihat detail',
        color: 'danger',
        fixed: false,
        icon: 'warning',
        click: () => { window.scrollTo(0, 0); },
      });
    },
    initEdit() {
      const ref = this.$route.params.ref;
      if (!ref) return;
      this.formdata.isEdit = true;
      this.$http.get('/api/accountpayable/' + ref).then(resp => {
        const d = resp.data;
        this.formdata.tanggal       = this.toDdmmyyyy(d.tanggal);
        this.formdata.jatuh_tempo   = this.toDdmmyyyy(d.jatuh_tempo);
        this.formdata.jenis_hutang  = d.jenis_hutang  || 'lokal';
        this.formdata.sup_id        = d.sup_id        || null;
        this.formdata.nama_supplier = d.nama_supplier || '';
        this.formdata.no_referensi  = d.no_referensi  || '';
        this.formdata.nomor_fp      = d.nomor_fp      || '';
        this.formdata.keterangan    = d.keterangan    || '';

        if (d.details && d.details.length > 0) {
          this.detailRows = d.details.map(row => ({
            kode_perk:  row.kode_perk  || '',
            nama_perk:  row.nama_perk  || '',
            keterangan: row.keterangan || '',
            nilai:      Number(row.nilai) || 0,
          }));
        }
      }).catch(() => {
        this.$vs.notify({ title: 'Error', text: 'Gagal memuat data', color: 'danger' });
      });
    },
  },

  mounted() {
    this.formdata.opr = this.$store.getters.getUserName || '-';
    this.fetchSupplier();
    this.fetchPerk();
    this.initEdit();
  },
};
</script>

<style src='@/assets/styles/jqwidgets/jqx.base.css'></style>
<style lang="stylus">
/* ===== Selector Jenis Hutang ===== */
.jenis-hutang-selector
  background #f9f9fb
  border 1px solid #e8e8f0
  border-radius 10px
  padding 14px 16px

.selector-label
  font-weight 600
  font-size 0.9em
  color #555
  margin-bottom 10px
  display block

.selector-options
  display flex
  gap 14px
  flex-wrap wrap

.selector-item
  flex 1
  min-width 180px
  border 2px solid #ddd
  border-radius 8px
  padding 12px 16px
  cursor pointer
  transition all 0.2s ease
  background #fff
  color #555
  &:hover
    border-color #90caf9
    background #e3f2fd

.selected-lokal
  border-color #1976d2 !important
  background #e3f2fd !important
  color #1565c0 !important
  font-weight 600

.selected-impor
  border-color #e65100 !important
  background #fff3e0 !important
  color #e65100 !important
  font-weight 600

.coa-info
  font-size 0.8em
  color #888
  margin-top 8px

/* ===== Badge header ===== */
.jenis-badge
  display inline-block
  padding 2px 10px
  border-radius 12px
  font-size 0.65em
  vertical-align middle
  font-weight 700
  letter-spacing 0.5px

.badge-lokal
  background #e3f2fd
  color #1565c0
  border 1px solid #90caf9

.badge-impor
  background #fff3e0
  color #e65100
  border 1px solid #ffcc80

/* ===== Detail rows ===== */
.detail-row
  border-radius 6px
  margin-bottom 6px

.row-even
  background #fafafa

.row-odd
  background #f4f6fb

/* ===== Total table ===== */
.total-table
  min-width 320px
  td
    padding 4px 8px

.kredit-val
  color #1565c0
</style>
